/**
 * File type utilities
 */

/**
 * Check if a file is an image type based on its MIME type
 */
export const isImageFile = (file: File): boolean => {
    return file.type.startsWith('image/');
};

/**
 * Check if a MIME type represents an image
 */
export const isImageMimeType = (mimeType: string | undefined): boolean => {
    return mimeType?.startsWith('image/') ?? false;
};

/**
 * Format file size for display
 */
export const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
};

/**
 * Get icon name based on file type
 */
export const getFileIcon = (fileType: string): string => {
    const type = fileType.toLowerCase();
    if (['pdf'].includes(type)) return 'file-text';
    if (['doc', 'docx'].includes(type)) return 'file-text';
    if (['xls', 'xlsx'].includes(type)) return 'file-spreadsheet';
    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(type)) return 'image';
    return 'file';
};
